import React from "react";
import { Link } from "react-router-dom";
import logo from "../icons/gymx-final-black.png";
import authPhoto from "../images/auth_bg.jpg";

function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-[100dvh] grid grid-cols-1 lg:grid-cols-2 bg-gx-navy">
      <div className="relative hidden lg:block min-h-[100dvh]">
        <img
          src={authPhoto}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gx-navy/55" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="text-3xl font-semibold tracking-tight max-w-md">
            Run the floor from one desk.
          </p>
          <p className="mt-3 text-white/80 max-w-sm">
            Memberships, billing, attendance and POS in one place.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center px-4 py-10 bg-gx-canvas min-h-[100dvh]">
        <div className="w-full max-w-md bg-gx-surface rounded-gx shadow-gx border border-gx-border p-8">
          <Link to="/" className="inline-block mb-6">
            <img src={logo} alt="GymXS" className="h-10 w-auto" />
          </Link>
          <h1 className="text-2xl font-semibold text-gx-ink tracking-tight">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm text-gx-ink-soft mt-2 mb-6">{subtitle}</p>
          ) : (
            <div className="mb-6" />
          )}
          {children}
          {footer}
        </div>
      </div>
    </div>
  );
}

export function AuthField({
  id,
  label,
  error,
  type = "text",
  children,
  ...props
}) {
  return (
    <div className="flex flex-col gap-2 mb-4">
      <label htmlFor={id} className="text-sm font-medium text-gx-ink">
        {label}
      </label>
      {children || (
        <input
          id={id}
          type={type}
          className={`h-11 rounded-gx-control border bg-gx-surface px-3 text-gx-ink outline-none focus:ring-2 focus:ring-gx-teal ${
            error ? "border-gx-red" : "border-gx-border"
          }`}
          {...props}
        />
      )}
      {error ? <p className="text-sm text-gx-red">{error}</p> : null}
    </div>
  );
}

export default AuthShell;
